import React from "react"; 
import { Link } from "react-router-dom";    
import DeliveryTermsListContent from "../../../components/Dashboard/DeliveryTermsListContent";

const DeliveryTermsList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of Delivery Terms </h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Delivery Terms List</li>
        </ul>
      </div> */}

      <DeliveryTermsListContent />
    </>
  );
};

export default DeliveryTermsList;
